import { allowedCancelReasons, type CancelReason, type CaseForPharmacy } from "@omony/domain";
import { Button, FormDialog, Select } from "@omony/ui";
import { XCircle } from "lucide-react";
import { useState } from "react";
import { ErrorBanner } from "../../shared/auth/screens.js";
import { useCaseAction } from "../data.js";
import { useT } from "./common.js";

/** Vorgang abbrechen (T11/T12): immer bestätigt, mit Grund; Fokus liegt auf „Nicht abbrechen“ */
export function CancelButton({ c }: { c: CaseForPharmacy }) {
  const t = useT();
  const reasons = allowedCancelReasons(c.status, "apotheke").filter(
    (r) => r !== "notfall" && r !== "nicht_geeignet",
  );
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState<CancelReason>(reasons[0] ?? "apotheke_abbruch");
  const cancel = useCaseAction<{ version: number; reason: CancelReason }>(c.id, "cancel");
  if (!reasons.length) return null;
  return (
    <>
      <Button variant="quiet" icon={<XCircle />} onPress={() => setOpen(true)}>
        {t("console.cancel.button")}
      </Button>
      <FormDialog
        isOpen={open}
        onOpenChange={setOpen}
        title={t("console.cancel.title")}
        actions={
          <>
            {/* Fokus auf der sicheren Aktion (WAI-ARIA-Dialogmuster) */}
            {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
            <Button variant="secondary" autoFocus onPress={() => setOpen(false)}>
              {t("console.cancel.keep")}
            </Button>
            <Button
              variant="danger"
              isDisabled={cancel.isPending}
              onPress={() =>
                cancel.mutate({ version: c.version, reason }, { onSuccess: () => setOpen(false) })
              }
            >
              {t("console.cancel.confirm")}
            </Button>
          </>
        }
      >
        <p>
          {t(
            c.status === "angenommen" || c.status === "in_behandlung"
              ? "console.cancel.leadCall"
              : "console.cancel.lead",
          )}
        </p>
        <Select
          label={t("console.cancel.reason")}
          value={reason}
          onChange={(v) => setReason(v as CancelReason)}
          options={reasons.map((r) => ({ id: r, label: t(`case.cancel.${r}`) }))}
        />
        <ErrorBanner error={cancel.error} />
      </FormDialog>
    </>
  );
}
